import React from "react";
import "./CpapAvailabilitySummary.css";

const CpapAvailabilitySummary = ({
  machines, loading, error, brand = "", model = "", onFilterChange,
  status = "ทั้งหมด", onStatusChange,
}) => {
  const records = machines.map((machine) => ({
    brand: String(machine.Brand || "").trim() || "Unknown",
    model: String(machine.Model || "").trim() || "Unknown",
    available: machine.Status === "ว่าง",
  }));
  const brands = Array.from(new Set(records.map((record) => record.brand))).sort((a, b) => a.localeCompare(b));
  const brandRecords = records.filter((record) => !brand || record.brand === brand);
  const modelOptions = Array.from(new Set(brandRecords.map((record) => record.model))).sort((a, b) => a.localeCompare(b));
  const counts = new Map();
  brandRecords.filter((record) => !model || record.model === model).forEach((record) => {
    counts.set(record.model, (counts.get(record.model) || 0) + (record.available ? 1 : 0));
  });
  const models = Array.from(counts.entries()).sort(([a], [b]) => a.localeCompare(b));
  const total = models.reduce((sum, [, count]) => sum + count, 0);

  return (
    <section className="cpap-availability" aria-labelledby="cpap-availability-title" aria-busy={loading}>
      <div className="cpap-availability-toolbar">
        <div className="cpap-availability-filters">
          <div className="cpap-availability-filter">
            <label htmlFor="cpap-availability-brand">Brand</label>
            <select id="cpap-availability-brand" className="form-control" value={brand}
              disabled={loading || error} onChange={(event) => {
                onFilterChange(event.target.value, "");
              }}>
              <option value="">All Brands</option>
              {brands.map((name) => <option key={name} value={name}>{name}</option>)}
            </select>
          </div>
          <div className="cpap-availability-filter">
            <label htmlFor="cpap-availability-model">Model</label>
            <select id="cpap-availability-model" className="form-control" value={model}
              disabled={loading || error} onChange={(event) => onFilterChange(brand, event.target.value)}>
              <option value="">All Models</option>
              {modelOptions.map((name) => <option key={name} value={name}>{name}</option>)}
            </select>
          </div>
          {(brand || model) && (
            <div className="cpap-availability-filter">
              <label htmlFor="cpap-availability-status">Status</label>
              <select id="cpap-availability-status" className="form-control" value={status}
                disabled={loading || error} onChange={(event) => onStatusChange(event.target.value)}>
                <option value="ทั้งหมด">ทั้งหมด</option>
                <option value="ว่าง">ว่าง</option>
                <option value="ไม่ว่าง">ไม่ว่าง</option>
                <option value="ยกเลิกใช้งาน">ยกเลิกใช้งาน</option>
              </select>
            </div>
          )}
          {(brand || model) && (
            <button type="button" className="btn btn-light" onClick={() => {
              onFilterChange("", "");
            }}>Clear filters</button>
          )}
        </div>
        <div className="cpap-availability-heading">
          <div>
            <h4 id="cpap-availability-title">Available</h4>
          </div>
          {!loading && !error && (
            <div className="cpap-availability-total">
              <strong>{total.toLocaleString()}</strong>
              <span>machines available</span>
            </div>
          )}
        </div>
      </div>
      {loading ? (
        <div className="cpap-availability-message" role="status">Loading availability…</div>
      ) : error ? (
        <div className="cpap-availability-message text-danger" role="alert">Unable to load availability. Please refresh the page.</div>
      ) : models.length === 0 ? (
        <div className="cpap-availability-message">No CPAP Trial machines match these filters.</div>
      ) : (
        <dl className="cpap-availability-models">
          {models.map(([model, count]) => (
            <div key={model} className={`cpap-availability-model${count === 0 ? " cpap-availability-model-empty" : ""}`}>
              <dt>{model}</dt>
              <dd aria-label={`${count} available`}>{count.toLocaleString()}</dd>
            </div>
          ))}
        </dl>
      )}
    </section>
  );
};

export default CpapAvailabilitySummary;
